module.exports = __webpack_public_path__ + "static/media/obg.d5353dfa.png";